import colors from '@do/walrus/scss/core/_colors.scss';
import vars from '@do/walrus/scss/core/_variables.scss';
import * as React from 'react';
import styled from 'styled-components';
import { HEADER_HEIGHT } from '../constants';

const BackgroundElt = styled.div`
  position: fixed;
  z-index: ${vars.z_index_base};
  top: ${HEADER_HEIGHT}px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.primary_bg};
  background-size: cover;
`;

interface Props {
  url: string;
  verticalPosition?: string;
  horizontalPosition?: string;
}

const Background: React.FC<Props> = ({
  url,
  verticalPosition = 'center',
  horizontalPosition = 'center'
}) => {
  return (
    <BackgroundElt
      style={{
        backgroundImage: `url(${url})`,
        backgroundPosition: `${horizontalPosition} ${verticalPosition}`
      }}
    />
  );
};

export default Background;
